import { DraftState } from '@/types';
import { getDraft } from '@/redux/draft/getters/getDraft';
import { StoreState } from '@/redux/types';
import { getPriceBreakdown } from './getPriceBreakdown';

export const selectPriceBreakdown = (state: StoreState) =>
  getPriceBreakdown(getDraft(state), state);

export const selectPriceBreakdownForDraft = (draft: DraftState) => (state: StoreState) =>
  getPriceBreakdown(draft, state);
